import React from 'react';

import '../styles/AboutAd.css';

const videoArray = [
  {
    key: '01',
    background : '#F2F2F2'
  },
  {
    key: '02',
    background : '#ffffff'
  },
  {
    key: '03',
    background : '#F2F2F2'
  },

]

const AboutAd = props => (
  <div>
  {
    videoArray.map(value => 
      <div className="about-ad-wrapper" key={value.key} style={{background : value.background}}>
        <div className={`ad-content ad-content-${value.key}`}>
          {/* <video preload="auto" autoPlay loop muted className={`ad-content-video ad-content-video-${value.key}`} key={require(`../img/about-adsticker/${value.key}.mp4`)}>
            <source src={require(`../img/about-adsticker/${value.key}.mp4`)} type="video/mp4"/>
          </video> */}
          <img src={require(`../img/about-adsticker/${value.key}.gif`)} className={`ad-content-video ad-content-video-${value.key}`}/>
        </div>
      </div>
    )
  }
  </div>
);
export default AboutAd;
